import { computed, Injectable } from '@angular/core';
import { AnamnesisObject } from '@libs/types/src/services/object-type/anamnesis/anamnesis.object';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';

@Injectable()
export class FolderAnamnesisWidgetStore extends ComponentStoreV2Factory {

    public readonly anamnesis = computed<AnamnesisObject | null>(() =>
        this.data.getAnamneses()?.items?.[0] ?? null,
    );
}
